<template>
  <div
    class="sidebar-left"
    :class="[SIDE_MENU == 1 ? 'opensidebar' : 'closesidebar']"
  >
    <ToolbarIcon />
    <div class="sidebar-body scroll-pane">
      <div class="side-nav">
        <div v-for="(menuItems, index) in menu" :key="index" class="menu-group">
          <router-link
            v-for="(item, index1) in menuItems"
            :key="index1"
            :to="item.route"
            class="menu-item"
            @click.native="Toggle"
          >
            <font-awesome-icon :icon="item.icon" class="icon menu-icon" />
            <span class="ml-3 menu-text">{{ $t(item.title) }}</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import { mapActions, mapGetters } from "vuex";
import ToolbarIcon from "./ToolbarIcon";

export default {
  components: { ToolbarIcon },
  data() {
    return {
      sidebar: "sidebar",
      menu: [
        [
          {
            title: "navigation.dashboard",
            icon: "tachometer-alt",
            route: "/funder/dashboard"
          },
          {
            title: "navigation.clients",
            icon: "user",
            route: "/funder/clients"
          }
        ],
        [
          {
            title: "navigation.invoices",
            icon: "file-alt",
            route: "/funder/invoices"
          },
          {
            title: "navigation.payments",
            icon: "credit-card",
            route: "/funder/payments"
          },
          {
            title: "navigation.preapproved_invoices",
            icon: "file-invoice",
            route: "/funder/preapproved-invoices"
          },
          {
            title: "navigation.tijarah_financing",
            icon: "shopping-bag",
            route: "/funder/islamic-finances"
          },
          {
            title: "navigation.po_financing",
            icon: "file-invoice",
            route: "/funder/purchaseorder-financing"
          }
        ],
        [
          {
            title: "navigation.reports",
            icon: "signal",
            route: "/funder/reports"
          },
          {
            title: "navigation.data_exports",
            icon: "file-export",
            route: "/funder/data-exports"
          }
        ],
        [
          {
            title: "navigation.settings",
            icon: "cog",
            route: "/funder/settings"
          },
          {
            title: "navigation.user_guides",
            icon: "file-pdf",
            route: "/funder/user-guides"
          }
        ]
      ]
    };
  },
  created() {
    if (localStorage.getItem("role") == "admin") {
      this.menu.splice(3, 0, [
        {
          title: "navigation.user_management",
          icon: "users-cog",
          route: "/funder/user-managements"
        }
      ]);
    }
  },
  computed: {
    ...mapGetters("general", ["SIDE_MENU"])
  },
  methods: {
    Toggle() {
      this.$utils.toggleSidebar();
    }
  }
};
</script>
